export const locale = {
    lang: "en",
    data: {
        CHARTS: {
            Title: "Charts",
            ChartConfiguration: "Chart Configuration",
            SeriesConfiguration: "Series Configuration",
            Devices: "Devices",
            DataPoint: "Data Point",
            Series: "Series",
            Device: "Device",
            Actions: "Actions",
            AddSeries: "Add Series",
            AddButton: "Add",
            RemoveButton: "Remove",
            DevicesHint: "Choose a device from the current project.",
            DataPointHint: "Pick the metric you want to add to the graph, including L10/L90 series.",
            NoProjectSelected: "Select a project first to compare chart data.",
            NoDevicesAvailable: "No devices are available in the current project.",
            NoSeriesSelected: "Add at least one device and data point to display the chart.",
            NoChartData: "No chart data is available for the current setup.",
        },
    },
};
